module.exports = __webpack_public_path__ + "img/jet6_feature_01.38248587.jpg";